/*
 * @Author: 陈浩彬
 * @Date: 2021-09-07 15:15:36
 * @LastEditTime: 2021-09-09 18:04:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \logistics-fe-otp\src\modules\otp\api\algorithmParameters.js
 */
import request from '@/utils/http';

// 主页列表数据
export const getSearchList = (data) => {
    return request({
        url: `/api-tms/baseAlgorithmParams`,
        method: 'post',
        data
    });
};
// 根据id获取详情
export const getDetail = (id) => {
    return request({
        url: `/api-tms/baseAlgorithmParam/${id}`,
        method: 'get'
    });
};
// 根据服务平台获取详情
export const getSearchDetail = (data) => {
    return request({
        url: `/api-tms/baseAlgorithmParam/getBySiteCodeInculdeCoverSite`,
        method: 'post',
        data
    });
};
// 删除
export const deleteByIds = (params) => {
    return request({
        url: `/api-tms/baseAlgorithmParams`,
        method: 'delete',
        data: params
    });
};
// 删除车型
export const deleteCarByIds = (id) => {
    return request({
        url: `/api-tms/baseAlgorithmParamCars/${id}`,
        method: 'delete'
    });
};

// 新增
export const addDate = (params) => {
    return request({
        url: `/api-tms/baseAlgorithmParam`,
        method: 'post',
        data: params
    });
};
// 编辑
export const editDate = (params, id) => {
    return request({
        url: `/api-tms/baseAlgorithmParam/${id}`,
        method: 'put',
        data: params
    });
};
// 获取车型字典值
export const getCarListApi = (params) => {
    return request({
        url: `/api-tms/algorithm/equipment/dict/query`,
        method: 'post',
        data: params
    });
};
